export const deleteEmployerPaymentMethod = async (
    API_URL: string,
    token: string,
    employerId: string,
    paymentMethodId: string
) => {
    await fetch(
        `${API_URL}/employers/${employerId}/payment-methods/${paymentMethodId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
    );
   
}